import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { Router } from '@angular/router';
import { DialogReplyService } from 'src/app/services/Non-Master/DialogReply.service';

import { tChangeAcctModel } from 'src/app/models/tChangeAcctModel';
import { tChangeAcctService } from 'src/app/services/tChangeAcct.service';

import { MatTableDataSource, MatPaginator } from '@angular/material';
import { FormControl } from '@angular/forms';


@Component({
  selector: 'app-search-patient-change-acct-dialog',
  templateUrl: './search-patient-change-acct-dialog.component.html',
  styleUrls: ['./search-patient-change-acct-dialog.component.css']
})
export class SearchPatientChangeAcctDialogComponent implements OnInit {

  selectedRowIndex: number = -1;

  bntStyle: string;

  changeNameFilter = new FormControl();
  changeNameEngFilter = new FormControl();
  changeAttnFilter = new FormControl();

  filteredValues = {
    changeName: '', changeNameEng: '', changeAttn: ''
  };


  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private router: Router,
    private dialogReplyService: DialogReplyService,
    private tChangeAcctService: tChangeAcctService,
  ) { }

  dataSource: MatTableDataSource<tChangeAcctModel>;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedColumns: string[] = [
    // 'action_button_title',

    'changeID',
    'changeNameAll',
    // 'changeAttn'

  ];

  TAG = "SearchPatientChangeAcctDialogComponent";
  // displayMsg: string;
  @Input() action: string;
  @Input() status: string;
  @Input() tableKeyValue: string;
  @Input() msg: string;


  ngOnInit() {

    this. bntStyle = 'btn-default';

    // switch (this.action) {
    //   case MastersKeyStringValue.ACTION_MessageDialog:
    //     this.setHideCancelButton();
    //     break;
    //   default:
    //     break;
    // }

    this.getAllData();

  }


  // doChange() {
  //   this.activeModal.dismiss('OK');
  // }

  // doReplyYes() {
  //   // this.dialogReplyService.doDialogReply('Y');
  //   this.activeModal.close('Y');
  // }

  // doReplyNo() {
  //   // this.dialogReplyService.doDialogReply('N');
  //   this.activeModal.close('N');
  // }


  getAllData(): void {
    this.log.i(this.TAG, 'TchangeacctComponent getAllProducts');

    this.tChangeAcctService.getAllData().subscribe(data => {
      //  this.dataList = data;

      this.dataSource = new MatTableDataSource<tChangeAcctModel>(data);
      this.dataSource.paginator = this.paginator;

      this.changeNameFilter.valueChanges.subscribe((changeNameFilter) => {
        this.filteredValues['changeName'] = changeNameFilter;
        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });

      this.changeNameEngFilter.valueChanges.subscribe((changeNameEngFilter) => {
        this.filteredValues['changeNameEng'] = changeNameEngFilter;
        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });

      this.changeAttnFilter.valueChanges.subscribe((changeAttnFilter) => {
        this.filteredValues['changeAttn'] = changeAttnFilter;
        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });
      this.dataSource.filterPredicate = this.customFilterPredicate();

    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim();
  }

  selectRow(selectedModel: tChangeAcctModel, index: number) {

    this.log.i(this.TAG, selectedModel.changeID.toString());

    this.selectedRowIndex = index;
    this.tChangeAcctService.shareSelected(selectedModel.changeID.toString());

    this.activeModal.close(selectedModel);
  }

  customFilterPredicate() {
    const myFilterPredicate = (data: tChangeAcctModel, filter: string): boolean => {

      let searchString = JSON.parse(filter);

      return data.changeName.toString().trim().toLowerCase().indexOf(searchString.changeName.toLowerCase()) !== -1 &&
        data.changeNameEng.toString().trim().toLowerCase().indexOf(searchString.changeNameEng.toLowerCase()) !== -1
        &&
        (searchString.changeAttn.toLowerCase() === '' ||
        (data.changeAttn != null && 
          data.changeAttn.toString().trim().toLowerCase().indexOf(searchString.changeAttn.toLowerCase()) !== -1));
    }
    return myFilterPredicate;
  }


}